import { memo, useCallback } from "react";

import { TextField } from "ui/components/TextField/TextField";
import { DatePicker } from "ui/components/DatePicker";
import { FleetFireExtinguisherSearchFormValues } from "services/api/fleet/vehicles/fireextinguishers/types";
import { FireExtinguisherSearchFiltersProps } from "./types";

import { useTranslate } from "helpers";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import VehicleManufacturerDropdown from "ui/components/Dropdown/VehicleManufacturerDropdown/VehicleManufacturerDropdown";
import VehicleModelDropdown from "ui/components/Dropdown/VehicleModelDropdown/VehicleModelDropdown";
import VehicleTypeDropdown from "ui/components/Dropdown/VehicleTypeDropdown/VehicleTypeDropdown";

const initialForm: FleetFireExtinguisherSearchFormValues = {
  search: "",
  expirationDateFrom: null,
  expirationDateTo: null,
  status: "",
  vehicleManufacturerId: null,
  vehicleModelId: null,
  vehicleTypeId: null,
};

const FireExtinguisherSearchFilters: React.FC<
  FireExtinguisherSearchFiltersProps
> = (props) => {
  const { formValues, onSearchChange } = props;
  const { t } = useTranslate();

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onSearchChange({ ...formValues, search: e.target.value });
  };

  const handleDateChange = (name: string, value: Date | null) => {
    onSearchChange({ ...formValues, [name]: value });
  };

  // Promjena marke prazni model i tip, promjena modela prazni tip — inače ostane
  // nemoguća kombinacija (model jedne marke uz drugu marku) i popis se isprazni.
  const handleManufacturerChange = (_e: any, _name: string, item: DropdownOption) => {
    onSearchChange({
      ...formValues,
      vehicleManufacturerId: item.value || null,
      vehicleModelId: null,
      vehicleTypeId: null,
    });
  };

  const handleModelChange = (_e: any, _name: string, item: DropdownOption) => {
    onSearchChange({ ...formValues, vehicleModelId: item.value || null, vehicleTypeId: null });
  };

  const handleTypeChange = (_e: any, _name: string, item: DropdownOption) => {
    onSearchChange({ ...formValues, vehicleTypeId: item.value || null });
  };

  const handleResetFormClick = useCallback(() => {
    onSearchChange(initialForm);
  }, [onSearchChange]);

  return (
    <>
      <div className=" ">
        <div className="flex flex-wrap items-end gap-3">
          <div className="min-w-[200px]">
            <TextField
              type="text"
              name="search"
              value={formValues.search}
              onChange={handleSearchChange}
              placeholder={t("admin.search.placeholder")}
              startIcon="../media/icons/search.svg"
              cssClassName="bg-white"
            />
          </div>
          <div className="min-w-[200px]">
            <VehicleManufacturerDropdown
              name="vehicleManufacturerId"
              placeholder={t("admin.vehicle.manufacturer.placeholder")}
              value={formValues.vehicleManufacturerId}
              onChange={handleManufacturerChange}
              width="full"
            />
          </div>
          <div className="min-w-[200px]">
            <VehicleModelDropdown
              name="vehicleModelId"
              placeholder={t("admin.vehicle.model.placeholder")}
              vehicleManufacturerId={formValues.vehicleManufacturerId}
              value={formValues.vehicleModelId}
              onChange={handleModelChange}
              width="full"
            />
          </div>
          <div className="min-w-[200px]">
            <VehicleTypeDropdown
              name="vehicleTypeId"
              placeholder={t("admin.vehicle.type.placeholder")}
              vehicleManufacturerId={formValues.vehicleManufacturerId}
              vehicleModelId={formValues.vehicleModelId}
              value={formValues.vehicleTypeId}
              onChange={handleTypeChange}
              width="full"
            />
          </div>
          <div className="w-[150px]">
            <DatePicker
              name="expirationDateFrom"
              label="Datum isteka od - do"
              value={formValues.expirationDateFrom}
              onChange={handleDateChange}
              cssClassName="bg-white"
            />
          </div>
          <div className="w-[150px]">
            <DatePicker
              name="expirationDateTo"
              value={formValues.expirationDateTo}
              onChange={handleDateChange}
              cssClassName="bg-white"
            />
          </div>
          <div className="flex items-center pb-2">
            <span
              onClick={handleResetFormClick}
              className="text-xs font-bold cursor-pointer text-gray-700"
            >
              {t("admin.reset")}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(FireExtinguisherSearchFilters);
